import Common from 'services/common'
import actions from './actions'

var payload = Common.getUserPayload()
if (payload && payload.role.indexOf('Admin - ') === -1 && payload.role.indexOf('User - ') === -1) {
  var historyURL = localStorage.getItem('historyURL')
  localStorage.clear()
  sessionStorage.clear()
  localStorage.setItem('historyURL',historyURL)
}

const initialState = {
  id: Common.getUserPayload() ? Common.getUserPayload()['id'] : '',
  name: Common.getUserPayload() ? Common.getUserPayload()['name'] : '',
  role: Common.getUserPayload() ? Common.getUserPayload()['role'] : '',
  email: Common.getUserPayload() ? Common.getUserPayload()['email'] : '',
  avatar: '',
  authorized: Common.getUserPayload() ? true : false,
  loading: false,
  licenseType: Common.getUserPayload() ? Common.getUserPayload()['licenseType'] : '',
  eulaStatus: true,
  otpInvalid: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_ACCDETAILS:
      return { ...state, ...action.payload }
    case actions.SET_SCOPEDETAILS:
      return { ...state, ...action.payload }
    case actions.VERIFY_OTP:
      return { ...state, ...action.payload }

    default:
      return state
  }
}
